module.exports = __webpack_public_path__ + "static/media/logo-global-2x.915c3622.png";